import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withTranslation } from "react-i18next";
import InfoRounded from "@mui/icons-material/InfoRounded";
import { IconButton } from "@mui/material";

class releaseHistory extends Component {
  handleHardReload = () => {
    // If checkbox is checked, send acknowledgment before reloading
    if (this.props.checked && this.props.notificationDetails) {
      console.log(`🔄 [Reload] Sending acknowledgment before reload for announcement ID: ${this.props.notificationDetails.id}`);
      
      fetch(
        process.env.REACT_APP_BASEURL + 'releasing/history/popUpNotification',
        {
          method: 'POST',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ announcementId: this.props.notificationDetails.id }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((response) => {
          console.log(`🔄 [Reload] Successfully acknowledged announcement before reload`, { response });
        })
        .catch((error) => {
          console.error(`❌ [Error] Failed to acknowledge announcement before reload`, error);
        })
        .finally(() => {
          // Always reload regardless of API success/failure
          this.performReload();
        });
    } else {
      // No acknowledgment needed, proceed with reload
      this.performReload();
    }
  }

  performReload = () => {
    const currentUrl = window.location.href;
    const hasCacheBust = currentUrl.includes("cache-bust");

    if (hasCacheBust) {
      window.location.reload(true); // Hard reload with cache clear
    } else {
      const newUrl = currentUrl.includes("?")
        ? `${currentUrl}&cache-bust=${new Date().getTime()}`
        : `${currentUrl}?cache-bust=${new Date().getTime()}`;
      window.location.replace(newUrl);
    }
  }

  render() {
    const {
      isOpen,
      closePopup,
      handelOnChangeCheckBox,
      notificationDetails,
      checked,
      t,
    } = this.props;
    return (
      <div>
        <div style={{ height: "50%", width: "50%" }}>
          <Dialog
            disableEscapeKeyDown
            open={isOpen}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                closePopup(event, reason);
              }
            }}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              {notificationDetails && notificationDetails.title}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {notificationDetails && notificationDetails.description}
              </DialogContentText>
              <br />
            </DialogContent>
            <DialogActions
              style={{ display: "flex", justifyContent: "space-between", alignItems: 'end' }}
            >
              <div>
                <DialogContentText style={{ display: 'flex', fontSize: '11px', width: '100%', color: 'black', alignItems: 'center' }}>
                  <IconButton aria-label="info">
                    <InfoRounded />
                  </IconButton> &nbsp;{t("Home.Announcement.ReleaseNote")}
                </DialogContentText>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={({ target }) =>
                        handelOnChangeCheckBox(target.checked)
                      }
                      color="primary"
                    />
                  }
                  style={{ marginLeft: 0, marginRight: 0 }}
                  label={
                    <span sx={{ color: "#000" }}>
                      {t("Home.UserPopup.DoNotShowAgain")}
                    </span>
                  }
                />
              </div>
              <div style={{ float: "right" }}>
                {[true, 'true'].includes(notificationDetails.is_reload_require) && (
                  <Button
                    onClick={this.handleHardReload}
                    type='cancel'
                    color='primary'
                    style={{ background: "#6cca98", color: "#fff" }}
                  >
                    Reload Now
                  </Button>
                )} &nbsp;
                <Button
                  onClick={closePopup}
                  type="cancel"
                  color="primary"
                  style={{ background: "#6cca98", color: "#fff" }}
                >
                  {t("Home.UserPopup.Close")}
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default withTranslation()(releaseHistory);



// WEBPACK FOOTER //
// ./src/components/userPopUpNotification/index.js